module.exports = __webpack_public_path__ + "static/king-cole-ducks-logo-6dc9533aed0ad23344cf0749e556ec22.jpg";